import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";

@Component({
  selector: 'app-cancel-button',
  templateUrl: './cancel-button.component.html',
  styleUrls: ['./cancel-button.component.css']
})
export class CancelButtonComponent implements OnInit {

  spin: boolean = false;

  constructor(private _location: Location) { }

  ngOnInit() {

  }

  CancelBtn(){

    this.spin =true;
    this._location.back();
  }

}
